/**
 * Query keys for the permission service. Kept in their own module (no axios import) so the
 * axios interceptor can invalidate the caller's permissions on a 403 without an import cycle.
 */
export const permissionQueryKeys = {
  all: () => ['permissions'] as const,
  me: () => ['permissions', 'me'] as const,
  roles: () => ['permissions', 'roles'] as const,
  catalogue: () => ['permissions', 'catalogue'] as const,
  matrix: () => ['permissions', 'matrix'] as const,
}
